module.exports = __webpack_public_path__ + "img/logo_hxsw.37929447.jpg";